"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button.new";
import { BodySmall } from "@/components/ui/typography";
import { Menu, X } from "lucide-react";
import Link from "next/link";
import { Separator } from "@/components/ui/separator";
import { useTranslations } from "next-intl";
type Props = {
  className?: string;
  navLinks?: Array<{
    id: string;
    label: string;
    href: string;
  }>;
} & ({
  logo?: string;
  name?: never;
} | {
  logo?: never;
  name: string;
});
export const Header = t0 => {
  const $ = _c(15);
  const {
    className,
    ...props
  } = t0;
  const t = useTranslations("welcome");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const {
    logo
  } = props;
  const {
    navLinks: t1
  } = props;
  const navLinks = t1 === undefined ? [] : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("border-border bg-muted sticky top-0 z-50 w-full border-b", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsMobileMenuOpen(false);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t("heroSection.cta.primary");
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div id="nav-cta" className="hidden md:flex md:items-center"><Button onClick={t3} className="w-full" purpose="primary" shape="pill" asChild={true}><a href="#book-demo">{t4}</a></Button></div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isMobileMenuOpen) {
    t6 = () => setIsMobileMenuOpen(!isMobileMenuOpen);
    $[7] = isMobileMenuOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="sr-only">Open navigation</span>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isMobileMenuOpen) {
    t8 = isMobileMenuOpen ? <X className="block h-6 w-6" aria-hidden="true" /> : <Menu className="block h-6 w-6" aria-hidden="true" />;
    $[10] = isMobileMenuOpen;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <div id="nav-mobile-toggle" className="md:hidden"><button type="button" className="text-foreground hover:bg-muted hover:text-foreground focus:ring-primary inline-flex items-center justify-center rounded-md p-2 focus:ring-2 focus:outline-none focus:ring-inset" onClick={t6} aria-expanded="false">{t7}{t8}</button></div>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return <nav id="navigation" className={t2}><div className="mx-auto px-4 sm:px-6 lg:px-18"><div className="flex h-16 items-center justify-between"><div id="nav-logo" className="flex items-center gap-3"><Link href="/" className="text-primary text-2xl font-extrabold tracking-tighter">{logo ? <img src={logo} alt="Logo" className="h-8 w-auto" /> : props.name}</Link></div>{navLinks.length > 0 && <div id="nav-links" className="hidden flex-1 md:ml-8 md:flex md:items-center md:space-x-5">{navLinks.map(item => <Link key={item.id} href={item.href as import("next").Route} onClick={() => setIsMobileMenuOpen(false)} className="text-foreground hover:text-primary rounded-lg px-2 py-2 transition-colors"><BodySmall className="font-medium">{item.label}</BodySmall></Link>)}</div>}{t5}{t9}</div>{isMobileMenuOpen && <div id="nav-mobile-menu" className="md:hidden"><div className="space-y-1 px-2 pt-2 pb-3 sm:px-3">{navLinks.map(item_0 => <Link key={item_0.id} href={item_0.href as import("next").Route} onClick={() => setIsMobileMenuOpen(false)} className="text-foreground hover:text-primary rounded-lg px-2 py-2 transition-colors"><BodySmall className="font-medium">{item_0.label}</BodySmall></Link>)}<Separator className="mb-4" /><Button onClick={() => setIsMobileMenuOpen(false)} className="w-full" purpose="primary" shape="pill" asChild={true}><a href="#book-demo">{t("heroSection.cta.primary")}</a></Button></div></div>}</div></nav>;
};